class StoreMarkers {
  constructor() {
    this.markers = [];
    this.clustering = [];
  }

  getMarkers() {
    return this.markers;
  }

  getClustering() {
    return this.clustering;
  }

  reset() {
    this.markers = [];
    this.clustering = [];
  }

  setMarkers(values) {
    this.markers = values;
  }

  setClustering(values) {
    this.clustering = values;
  }
}

export default StoreMarkers;
